import { app } from '../../../../../app';
import { Controller } from './paused-users.controller';

app.component('companyUserDirectoriesSaaspassUsersPausedUsers', {
    bindings: {
		pausedUsers: '<',
		companyId: '<',
		labels: '<',
        numberOfUsers: '<',
    },
    controller: Controller,
    templateUrl: require('./paused-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/paused-users/paused-users.component.js